import { type FC } from 'react'

import { ProductHeadGenericLabel } from '../../../../../../product'
import { useProductPageContext } from '../../../../productPageContext'
import { type ProductHeadLabel } from '../../ProductHeadLabelsTypes'

import { DynamicProductHeadBioLabel } from './DynamicProductHeadBioLabel'
import { shouldRenderBioLabel } from './shouldRenderBioLabel'

type ProductHeadBioLabelRendererProps = {
  label: ProductHeadLabel
}

export const ProductHeadBioLabelRenderer: FC<
  ProductHeadBioLabelRendererProps
> = ({ label }) => {
  const { currentOffer } = useProductPageContext()

  if (shouldRenderBioLabel(currentOffer)) {
    return <DynamicProductHeadBioLabel />
  }

  return (
    <ProductHeadGenericLabel className="border-dark-primary-min bg-light-primary-low">
      {label.labelText}
    </ProductHeadGenericLabel>
  )
}
